function auditSkeletonLoading () {
  return {
    restrict: 'E',
    templateUrl: '/audit/directives/audit-skeleton-loading/audit-skeleton-loading.html?$$REVISION$$'
  }
}

export { auditSkeletonLoading }
